import {request} from '@/helpers/apiClient'
import {GLOBAL_API_CONFIG} from '@/utils/constants/apiConfig/globalApiConfig'

export const uploadFileService = options => request(GLOBAL_API_CONFIG.FILE_UPLOAD, options)
export const bulkUploadFileService = options => request(GLOBAL_API_CONFIG.BULK_PROMOTION_FILE_UPLOAD, options)
export const uploadSuggestedSKUsService = options => request(GLOBAL_API_CONFIG.UPLOAD_SUGGESTED_SKUS, options)